module.exports = __webpack_public_path__ + "static/media/banner12_old.b64bce2f.jpeg";